var map = {
	"./de/kv.jpg": "/CgL",
	"./en/kv.jpg": "TPAk",
	"./es/kv.jpg": "1O3k",
	"./fr/kv.jpg": "g5Pe",
	"./ja/kv.jpg": "XYyB",
	"./ko/kv.jpg": "+NeB",
	"./pt/kv.jpg": "rWsH",
	"./ru/kv.jpg": "xIVr",
	"./tc/kv.jpg": "OsE6",
	"./th/kv.jpg": "9iyM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jBIX";